import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';
import Upload from '../../organisms/UploadCustom';
import UploadPdf from '../../organisms/UploadCustomPDF';
import { Field, reduxForm, getFormValues, formValueSelector } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import * as validateRule from '../../validateRule';
import UserHeader from '../../organisms/UserHeader';
import { intl } from '../../../core/globalIntl';
import * as common from '../../common';
import conf from '../../../config/config.js';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 4px 16px 4px',
    backgroundColor: '#fafafa',
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',     
  },
  fields: {
    margin: '0px 10px 15px 10px',
  },
  fieldsPostal: {
    margin: '0px 0px 15px 10px',
    width: '90%',
  },
  fields3: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 4px 16px 4px',
    margin: '0',
  },
  fields4: {
    margin: '0px 1px 15px 10px',
    width: '200px',
  },
  fieldsPoleNum: {
    margin: '0px 1px 15px 10px',
    width: '53px',
    alignItems: 'right',
    textAlign: 'right',
    fontSize: '0.9em',
  },
  fieldsPoleNum2: {
    margin: '0px 1px 15px 0px',
    width: '68px',
  },
  fieldsPoleNum3: {
    margin: '0px 1px 15px 0px',
    width: '53px',
  },
  fieldsPoleChar: {
    margin: '0px 1px 15px 0px',
    width: '50px',
  },
  typography:{
    margin: '0 0 0 40px'
  },
  typography3:{
    margin: '10px 10px -10px 16px'
  },
  typography4:{
    margin: '10px 10px 0 16px'
  },
  textFieldDate: {
    margin: '0px 10px 15px 10px',
    width: '42%',
    minWidth: '240px',
  },
  button: {
    marginTop: '20px',
    marginLeft: '80px',
    marginRight: '80px',
  },
  formControl: {
    margin: '10px 20px 10px 20px',
  },
  formControl2: {
    margin: '10px 20px 0 20px',
  },
  formControl3: {
    margin: '-21px 20px 0 0',
    paddingLeft:"25px",
  },
  upload: {
    margin: '10px 20px 0px 10px',
    alignItems: 'center',
  },
  formLabel: {
    color: "#212121",
    margin: "0 0 5px -5px"
  },
  formLabel2: {
    color: "#212121",
    width: '30px',
  },
  formLabel3: {
    margin: '0px 10px 0px 7px',
    width: '50px',
    textAlign: "center",
  },
  formLabel4: {
    margin: '0px 10px 0px 0px',
    width: '35px',
    textAlign: "center",
  },
  formLabel5: {
    margin: '0px 10px 0px 0px',
    width: '45px',
    textAlign: "center"
  },
  formLabel6: {
    margin: '0px 10px 0px 0px',
    width: '68px',
    textAlign: "center",
  },  
  dateMark: {
    marginTop: "22px",
    fontSize: "1.2em",
  },
  typographySec: {
    color: "#d50000",
    border: "solid 1px #d50000",
    margin: '10px 10px 0 10px',
    padding: '0 0 0 5px',
    borderRadius: "0.1em",
    fontSize: "0.8em",
  },
  typographySecBlue: {
    color: "#2f5ff5",
    border: "solid 1px #2f5ff5",
    margin: '10px 10px 0 10px',
    padding: '0 0 0 5px',
    borderRadius: "0.1em",
    fontSize: "0.8em",
  },
  typographySecPole: {
    color: "#d50000",
    border: "solid 1px #c0c0c0",
    margin: '10px 10px 0 10px',
    padding: '0 0 0 5px',
    borderRadius: "0.3em",
    fontSize: "0.9em",
    height: "auto",
    width: "auto",
    maxWidth: "700px",
  },
  typographySecPoleWarn: {
    color: "#d50000",
    border: "solid 1px #f44336",
    margin: '10px 10px 0 10px',
    padding: '0 0 0 5px',
    borderRadius: "0.3em",
    fontSize: "0.9em",
    height: "auto",
    width: "auto",
    minHeight: "130px",
    maxWidth: "700px",
  },
  typographyWarn: {
    color: "#ffffff",
    backgroundColor: "#e60033",
    borderRadius: '99px',
    border: "solid 1px #e60033",
    margin: '10px 10px 0 10px',
    padding: '7px 4px 4px 8px',
    fontSize: "0.8em",
  },
  container1: {
    fontSize: "0.5em",
    margin: "40px 0 0 5px",
    width: '10px',
  },
  containerGridItem: {
    margin: "0 0 0 0",
    marginRight: "0",
    padding: '0',
  },
  label2: {
    padding: '0 0 0 10px',
    width: '100%',
  },
  label3: {
    width: '100%',
    color: "#eef3f8",
    fontSize: "1.0em"
  },
  serchbutton: {
    marginTop: '10px',
    marginLeft: '-5px',
  },
});

const RadioB = withStyles(theme => ({
  root: {
    padding: "0px 5px 0px 10px",
    '&$checked': {
      color: '#1976d2'
    }
  },
  checked: {
    },
}))(Radio);

/** 郵便番号チェックフラグ */
var postalCodeErrFlg = false;

/** 電柱管理番号入力形式 */
const inputTypeNumber = 1;
const inputTypeAlphabet = 2;
const inputTypeHalfKana = 3;

/** 電柱管理番号入力情報 */
const poleNoInfo = [
  {key: '1', name: "WorkSitePoleNo1__c", len: 2, type: inputTypeNumber, err: "", chkflg: false},
  {key: '2', name: 'WorkSitePoleNo2__c', len: 1, type: inputTypeAlphabet, err: "", chkflg: false},
  {key: '3', name: 'WorkSitePoleNo3__c', len: 2, type: inputTypeNumber, err: "", chkflg: false},
  {key: '4', name: 'WorkSitePoleNo4__c', len: 1, type: inputTypeHalfKana, err: "", chkflg: false},
  {key: '5', name: 'WorkSitePoleNo5__c', len: 4, type: inputTypeNumber, err: "", chkflg: false}
]

/** 資材数量入力情報 */
const shizaiInfo = [
  {key: '1', name: "HighVolVolume__c", len: 5, value: ''},
  {key: '2', name: 'LowVolVolume__c', len: 5, value: ''},
  {key: '3', name: 'DropVolume__c', len: 5, value: ''},
  {key: '4', name: 'ComVolume__c', len: 5, value: ''},
  {key: '5', name: 'TransOpenVolime__c', len: 5, value: ''}
]

var poleNoErrMsg = []
var poleNoChkFlg = false;
var poleNoErrFlg = false;

// 入力値Nullチェック
const isNull = (val) => {
  if (!val || val === undefined || val === '') {
    return true;
  }
  return false;
}

// 電柱番号共通チェック
const cmnPoleNoCheck = (values) => {
  poleNoErrFlg = false;
  for (const poleNo of poleNoInfo) {
    if (!poleNo.chkflg) {
      continue;
    }
    let val = common.full2Harf(values[poleNo.name]);
    if (!isNull(val)) {
      if (poleNo.type === 1) {
        // 数字形式のチェック
        if (val.length !== poleNo.len || !val.match(/^[0-9]+$/)) {
          poleNoErrMsg.push(intl.formatMessage({ id: 'inputCheckMessage.poleNo.number.length' }, {no: poleNo.key, len: poleNo.len }));
          poleNoErrFlg = true;
        }
      } else if (poleNo.type === 2) {
        // 半角英字形式のチェック
        if (val.length !== poleNo.len || !val.match(/^[a-zA-Z]/)) {
          poleNoErrMsg.push(intl.formatMessage({ id: 'inputCheckMessage.poleNo.alphabet.length' }, { no: poleNo.key, len: poleNo.len }));
          poleNoErrFlg = true;
        }
      } else {
        // 半角カナ形式のチェック
        if (val.length !== poleNo.len || !val.match(/^[ｱ-ﾝ]/)) {
          poleNoErrMsg.push(intl.formatMessage({ id: 'inputCheckMessage.poleNo.halfkana.length' }, { no: poleNo.key, len: poleNo.len }));
          poleNoErrFlg = true;
        }
      }
    }
  }
}

// 入力値チェック
const validate = (values) => {
  const errors = {};
  postalCodeErrFlg = false
  // 郵便番号必須チェック
  if (isNull(values.Postalcode__c)) {
    errors.Postalcode__c = {_error: intl.formatMessage({ id: 'inputCheckMessage.required' })};
    postalCodeErrFlg = true;
  } else {
    // 全角 ⇒ 半角変換
    values.Postalcode__c = common.full2Harf(values.Postalcode__c);
    let postalCd = values.Postalcode__c;
    // 桁数チェック
    if (!postalCd.match(/^\d{3}-?\d{4}$/)) {
      errors.Postalcode__c = {_error: intl.formatMessage({ id: 'inputCheckMessage.postalCd.format' })};
      postalCodeErrFlg = true;      
    }
  }

  for (const shizai of shizaiInfo) {
    // 資材数量に設定がある場合
    if (!isNull(values[shizai.name])) {
      // 全角 ⇒ 半角変換
      values[shizai.name] = common.full2Harf(values[shizai.name]);
      let suryo = values[shizai.name];
      // 数字チェック
      if (!suryo.match(/^[0-9]+$/)) {
        errors[shizai.name] = {_error: intl.formatMessage({ id: 'inputCheckMessage.number' })};
      }
      // 桁数チェック
      if (suryo.length > shizai.len) {
        errors[shizai.name] = {_error: intl.formatMessage({ id: 'inputCheckMessage.max' }, { max: shizai.len })};
      }
    }
  }

  if (poleNoChkFlg) {
    // 電柱番号共通チェック
    poleNoErrMsg = [];  
    cmnPoleNoCheck(values);
    poleNoChkFlg = false;
  }

  return errors;
};

const renderTextField = ({
  input,
  label,
  meta: { touched, error, valid },
  ...custom
}) => (
  <TextField
    label={label}
    helperText={touched && error}
    error={touched && !valid}
    {...input}
    {...custom}
  />
);

const renderCheckbox = ({ input, label,  meta: { touched, error, valid },
  ...custom  }) => {

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={input.value ? true : false}
          onChange={input.onChange}
          color="primary"
          style={{padding: "0px 6px 0 12px"}}
          {...custom}
        />
      }
      label = { label }
    />
  );
};

const renderRadioGroup = ({
 input,
 label,
 meta: { touched, error },
 ...rest
}) => (
   <div> {label}
     <RadioGroup
       {...input}
       {...rest}
     />
     {touched && error &&
       <Typography variant="caption" color="error">
         {error}
       </Typography>
     }
   </div>
 );

renderTextField.propTypes = {
  input: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  label: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  meta: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

class WorkRequest extends React.Component {

  state = {
    ImageDatas: [],
    ImagePdfDatas: [],
  };
  
  poleNoChkFlg = false;
  poleNoErrMsg = []
  poleNoErrFlg = false;

  // 郵便番号から住所検索
  getAddress = async () => {
    console.log("#住所検索呼出#");
    const { Postalcode__c } = this.state;
    const { getAddressAction } = this.props;   
    console.log("postalCodeErrFlg:" + postalCodeErrFlg);
    if(postalCodeErrFlg || 
       !Postalcode__c || Postalcode__c === undefined || Postalcode__c === ''){
      return;
    }

    try{
      let postalCd = common.full2Harf(Postalcode__c);
      console.log("検索郵便番号:" + postalCd);
      const result = await getAddressAction(postalCd);
      if (result.data.body.data.status === 200) {
        //正常
        if (result.data.body.data.results) {
          var info = result.data.body.data.results[0];
          console.log(info.address1,info.address2,info.address3);
          this.props.change('WorkSiteAddress__c', info.address1 + info.address2 + info.address3);
        } else {
          //データ無し
          const { doOpenDialog } = this.props;
          const dialog = {
            type: 'close', // '閉じる'のみ表示
            title: '',
            message: 'userRegist.dialog.error.nondata',
          };
          doOpenDialog(dialog);
        }
      } else if (result.data.body.data.status === 400) {
        // 入力値不正エラーだった場合
        const { doOpenDialog } = this.props;
        const dialog = {
          type: 'close', // '閉じる'のみ表示
          title: '',
          message: 'message.error.90000',
        };
        doOpenDialog(dialog);
      } else {
        //異常
        const { doOpenDialog } = this.props;
        const dialog = {
          type: 'close', // '閉じる'のみ表示
          title: 'system.message.error.title',
          message: 'userRegist.dialog.error.system',
        };
        doOpenDialog(dialog);
      }
    } catch (err) {
      console.log(`エラー: ${err}`);
      // システムエラーだった場合
      const { doOpenDialog } = this.props;
      const dialog = {
        type: 'error', // '閉じる'のみ表示
        title: 'system.message.error.title',
        message: 'system.message.error.context',
      };
      doOpenDialog(dialog);
    }                  
  }

  onChange = event => {
    const { name, value } = event.target;

    this.setState({
      [name]: value
    });
  }

  // 取付登録確認
  doWorkRequest = () => {

    const { doOpenDialog, values, userInfo, } = this.props;

    if (isNull(values.Postalcode__c)) {
        postalCodeErrFlg = true;
    } 

    if (isNull(values.WorkSitePoleNo1__c) || isNull(values.WorkSitePoleNo2__c) || isNull(values.WorkSitePoleNo3__c) ||
        isNull(values.WorkSitePoleNo4__c) || isNull(values.WorkSitePoleNo5__c)) {
        poleNoErrFlg = true;
    }

    if (postalCodeErrFlg || poleNoErrFlg) {
      return;
    }

    if (userInfo.data && userInfo.data.account) {
      if (!isNull(userInfo.data.account.BuyHoldCustomerLevel__c)) {
        var buylevel = (userInfo.data.account.BuyHoldCustomerLevel__c).slice(0, 1);
        if (buylevel && (buylevel === 'C' || buylevel === 'D')) {
          const dialog = {
            type: 'ok', // '閉じる'のみ表示
            title: '',
            message: 'workRequest.dialog.BuyLevelNg',
            action: this.onClickBack
          };
          doOpenDialog(dialog);
          return;
        }
      }
    }

    const dialog = {
      type: 'okcancel', // 「確認」と「キャンセル」を表示
      title: '',
      message: 'workRequest.dialog.inquiry',
      action: this.doAction
    };
    doOpenDialog(dialog);
  }

  // 取付登録処理
  doAction = async() => {

    console.log("#取付申込#");
    const { doWorkRequestAction, doOpenDialog, values } = this.props;
    if(postalCodeErrFlg){
      return;
    }
    try {
      values.Postalcode__c = common.full2Harf(values.Postalcode__c);
      for (const poleNo of poleNoInfo) {
        values[poleNo.name] = common.full2Harf(values[poleNo.name]);
      }
      console.log("pdf:" + this.state.ImagePdfDatas);
      const result = await doWorkRequestAction(this.state.ImageDatas, this.state.ImagePdfDatas);
      console.log(result);
      if (result === "00000") {
        // 正常
        const dialog = {
          type: 'ok', // '閉じる'のみ表示
          title: '',
          message: 'workRequest.dialog.finish',
          action: this.onClickBack
        };
        doOpenDialog(dialog);
      } else if (result === "20500" || result === "20501") {
        // 20500：お客様情報取得失敗(cognitoからの取得)
        // 20501：防護管申込 失敗
        const dialog = {
          type: 'ok', // '閉じる'のみ表示
          title: '',
          message: 'workRequest.dialog.error.failure',
          action: this.onClickBack
        };
        doOpenDialog(dialog);
      } else if (result === "ERROR_UPLOAD") {
        // ファイルアップロード失敗(メッセージを表示してメニュー画面表示)
        const dialog = {
          type: 'ok', // '閉じる'のみ表示
          title: '',
          message: 'workRequest.dialog.error.failure.upload',
          action: this.onClickBack
        };
        doOpenDialog(dialog);
      }
      else {
        // その他エラー
        const dialog = {
          type: 'error', // '閉じる'のみ表示
          title: 'system.message.error.title',
          message: 'system.message.error.context',
        };
        doOpenDialog(dialog);
      }
    }
    catch (err) {
      console.log(`エラー: ${err}`);
      // その他エラー
      const dialog = {
          type: 'error', // '閉じる'のみ表示
          title: 'system.message.error.title',
          message: 'system.message.error.context',
      };
      doOpenDialog(dialog);
    }

  };

  // 戻る(メニュー画面に遷移)
  onClickBack = () => {
    poleNoErrMsg = [];
    poleNoErrFlg = false;
    poleNoChkFlg = false;
    this.setInitPoleNoInfo();
    this.props.history.push('/workMenu');
  };

  // 写真アップロード
  setFiles = (e) => {
    this.setState({ImageDatas: e});
  }

  // 添付資料アップロード
  setPdfFiles = (e) => {
    this.setState({ImagePdfDatas: e});
  }

  // 郵便番号変更処理
  setPostalCodeValue = (e) => {
    const { value } = e.target;
    this.setState({ Postalcode__c: value })
  }

  // 電柱管理番号情報初期化
  setInitPoleNoInfo = () => {
    for (const poleno of poleNoInfo) {
        poleno.chkflg = false;
    }
  }

  // 電柱管理番号変更処理
  setPoleNoChange = (e) => {
    const { name } = e.target;
    poleNoChkFlg = true;
    this.setPoleNoChkFlg(name);
  }
  // 電柱管理番号変更フラグ設定
  setPoleNoChkFlg = (name) => {
    for (const poleno of poleNoInfo) {
      if (poleno.name === name) {
        poleno.chkflg = true;
        return;
      }
    }
  }

  // 電柱管理番号フォーカスアウト
  checkPoleNo = (e) => {
    const { values } = this.props;
    this.cnvFull2Harf(e);
    poleNoErrMsg = [];
    cmnPoleNoCheck(values);
  }

  // 資材数量変更処理
  setShizaiSuryo = (e) => {
  }

  // 全角 ⇒ 半角
  cnvFull2Harf = (e) => {
    const { name, value } = e.target;
    let harf = common.full2Harf(value);
    this.props.change(name, harf);
    e.preventDefault();
  }

  // 半角 ⇒ 全角
  cnvHarf2Full = (e) => {
    const { name, value } = e.target;
    let full = common.harf2Full(value);
    this.props.change(name, full);
    e.preventDefault();
  }

  setFontColor = () => {
    if (poleNoErrFlg) {
      return "#f44336"
    }
    return ""
  }
  
  setPoleClassName = () => {
    const { classes } = this.props;
    if (poleNoErrFlg) {
      return classes.typographySecPoleWarn;
    }
    return classes.typographySecPole;
  }

render() {
    const { classes, intl, handleSubmit, userInfo, values } = this.props;

    // 工事・作業の分類***
    const selKind1 = intl.formatMessage({ id: 'workRequest.select.architecture' });
    const selKind3 = intl.formatMessage({ id: 'workRequest.select.civilEngineering' });
    const selKind7 = intl.formatMessage({ id: 'workRequest.select.communicationLineEngineering' });
    const selKind8 = intl.formatMessage({ id: 'workRequest.select.workOther' });

    return (
      <div className={classes.root}>
      <form noValidate autoComplete="off" className={classes.root}>
      <UserHeader />

{/* 現場所在地 */}
        <Grid container>
          <Grid item xs={6} md={2}>
            <Field
              id="Postalcode__c"
              name="Postalcode__c"
              component={renderTextField}
              className={classes.fieldsPostal}
              label={<FormattedMessage id='workRequest.in.zipcode'/>}
              margin="normal"
              variant="outlined"
              type="text"
              required={true}
              validate={[
                validateRule.required,
              ]}
              onChange={this.setPostalCodeValue}
              onKeyDown={e => (e.keyCode === 69 || e.keyCode === 190 || e.keyCode === 187 || e.keyCode === 107) && e.preventDefault()}
            />
          </Grid>
          <Grid item xs={2} md={1} style={{maxWidth: '10px'}}></Grid>
          <Grid item xs={4} md={3}>
            <Button
              id="search"
              name="search"
              variant="contained"
              color="primary"
              className={classes.serchbutton}
              size="large"
              onClick={this.getAddress}
            >
            <span><FormattedMessage id={'userRegist.btn.search'} /></span>
            </Button>
          </Grid>
        </Grid>
        <Field
          id="WorkSiteAddress__c"
          name="WorkSiteAddress__c"
          component={renderTextField}
          className={classes.fields}
          label={<FormattedMessage id='workRequest.in.workaddress'/>}
          margin="normal"
          variant="outlined"
          type="text"
          required={true}
          validate={[
              validateRule.required,
              validateRule.maxLength(120),
              validateRule.fullWidth
          ]}
          onBlur={this.cnvHarf2Full}
        />
        <Typography variant="subtitle1" className={classes.typography3}><font size="3" color={this.setFontColor()}><FormattedMessage id={'workRequest.in.poleNumber'}/></font></Typography>
        <Typography variant="subtitle2" display="inline" className={this.setPoleClassName()}>
        <p style={{fontSize: 5, height: 1}}></p>
        <Grid container>
            <FormLabel component="legend" className={classes.formLabel3}><font size="3">例) 42</font></FormLabel>      
            <FormLabel component="legend" className={classes.formLabel4}><font size="3">G</font></FormLabel>
            <FormLabel component="legend" className={classes.formLabel5}><font size="3">22</font></FormLabel>
            <FormLabel component="legend" className={classes.formLabel4}><font size="3">ｶ</font></FormLabel>
            <FormLabel component="legend" className={classes.formLabel6}><font size="3">4510</font></FormLabel>
        </Grid>
        <Grid container>
          <Field
            id="WorkSitePoleNo1__c"
            name="WorkSitePoleNo1__c"
            component={renderTextField}
            margin="normal"
            variant="outlined"
            type="text"
            multiline={false}
            className={classes.fieldsPoleNum}
            onChange={this.setPoleNoChange}
            onBlur={this.checkPoleNo}
            validate={[
              validateRule.requiredPoleNo,
            ]}
          />
          <Field
            id="WorkSitePoleNo2__c"
            name="WorkSitePoleNo2__c"
            component={renderTextField}
            margin="normal"
            variant="outlined"
            type="text"
            multiline={false}
            className={classes.fieldsPoleChar}
            onChange={this.setPoleNoChange}
            onBlur={this.checkPoleNo}
            validate={[
              validateRule.requiredPoleNo,
            ]}
          />  
          <Field
            id="WorkSitePoleNo3__c"
            name="WorkSitePoleNo3__c"
            component={renderTextField}
            margin="normal"
            variant="outlined"
            type="text"
            multiline={false}
            className={classes.fieldsPoleNum3}
            onChange={this.setPoleNoChange}
            onBlur={this.checkPoleNo}
            validate={[
              validateRule.requiredPoleNo,
            ]}
          />                
          <Field
            id="WorkSitePoleNo4__c"
            name="WorkSitePoleNo4__c"
            component={renderTextField}
            margin="normal"
            variant="outlined"
            type="text"
            multiline={false}
            className={classes.fieldsPoleChar}
            onChange={this.setPoleNoChange}
            onBlur={this.checkPoleNo}
            validate={[
              validateRule.requiredPoleNo,
            ]}
          />      
          <Field
            id="WorkSitePoleNo5__c"
            name="WorkSitePoleNo5__c"
            component={renderTextField}
            label=""
            margin="normal"
            variant="outlined"
            type="text"
            multiline={false}
            className={classes.fieldsPoleNum2}
            onChange={this.setPoleNoChange}
            onBlur={this.checkPoleNo}
            validate={[
              validateRule.requiredPoleNo,
            ]}
          />
          <div style={{margin:"-10px 0 0 20px", height: "auto"}}>
            {poleNoErrMsg.map((errMsg) => (
              <>
                <Typography variant="subtitle2"
                  style={{display:"inline-block", fontSize:"0.75em", color:"red"}}>
                  {errMsg}
                </Typography>
                <br></br>
              </>
            ))}
          </div>        
        </Grid>
        </Typography>
        <Typography variant="body2" className={classes.typographyValue} style={{paddingLeft:"20px"}}>
            ・<u style={{color:'#0000ff', cursor:'hand'}}>
                <a target="_blank" rel="noopener noreferrer" href={conf.CLAUSE_PDF_URL}>
                電柱管理番号の確認方法
                </a>
              </u>
        </Typography>
        <p style={{fontSize: 5, height: 1}}></p>
        {/* 写真アップロード */}
        <Typography variant="subtitle1" className={classes.typography3}>写真アップロード<font size="2"><FormattedMessage id={'workRequest.title.multiSelect'}/></font></Typography>
        <Typography variant="subtitle2" display="inline" className={classes.typographySecBlue}><FormattedMessage id={'workRequest.message.picture'}/></Typography>
        <p style={{fontSize: 5, height: 1}}></p>
        <Typography variant="body2" className={classes.typographyValue} style={{paddingLeft:"20px"}}>
            ・<u style={{color:'#0000ff', cursor:'hand'}}>
                <a target="_blank" rel="noopener noreferrer" href={conf.ATTACHED_EXAMPLE_URL}>
                 電柱番号 提出例
                </a>
              </u>
        </Typography>        
        <Fragment>
          <div style={{paddingLeft:"20px"}}>
          <Upload
            componentId="photoFile"
            maxFileCount={10}
            maxFileSize={10485760}
            previewFlag={true}
            previewWidth="35%"
            acceptFileType=".jpg,.jpeg,.png,.gif"
            fileSetHandler={this.setFiles}
            />
            </div>
        </Fragment>
        <br/>
{/* 取付け希望期間 */}
        <Typography variant="subtitle1" className={classes.typography4}><FormattedMessage id={'workRequest.title.term'}/><font size="2">（※取付期間が１年以上の場合は、標準金額に対して追加料金が発生します。）</font></Typography>
        <p style={{fontSize: 5, height: 1}}></p>
        <Grid container>
          <Field
            id="StartRequireAttachTerm__c"
            name="StartRequireAttachTerm__c"
            component={renderTextField}
            label="取付を希望される日"
            className={classes.textFieldDate}
            margin="normal"
            variant = "outlined"
            type="date"
            required={true}
            InputLabelProps={{
              shrink: true,
            }}
            validate={[
              validateRule.requiredDate,
              validateRule.oldDate,
              validateRule.dateLength,
            ]}
          />
          <Typography className={classes.dateMark}>～</Typography>
          <Field
            id="EndRequireAttachTerm__c"
            name="EndRequireAttachTerm__c"
            className={classes.textFieldDate}
            component={renderTextField}
            label="防護管が不要となる日"
            margin="normal"
            variant = "outlined"
            required={true}
            type="date"
            InputLabelProps={{
              shrink: true,
            }}
            validate={[
              validateRule.requiredDate,
              validateRule.oldDate,
              validateRule.dateLength,
              validateRule.correctDate(values.StartRequireAttachTerm__c)
            ]}
          />
        </Grid>

{/* 工事・作業の分類 */}
        <div style={{paddingBottom:"0px"}}>
          <FormControl component="fieldset" className={classes.formControl2}>
            <FormLabel component="legend" className={classes.formLabel}><FormattedMessage id={'workRequest.title.worktype'}/></FormLabel>
            <div style={{paddingLeft:"1px", width:"780px"}}>
              <Field name="Purpose__c" id="Purpose__c" className={classes.fields} required={true} component={renderRadioGroup} row>
              <Grid container >
                <Grid item xs={12} md={2}>
                  <FormControlLabel 
                    value={selKind1} 
                    control={<RadioB checked={values.Purpose__c === selKind1 ? true: false} />} 
                    label={<FormattedMessage id='workRequest.select.architecture'/>} 
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                <FormControlLabel 
                  value={selKind3} 
                  control={<RadioB checked={values.Purpose__c === selKind3 ? true: false} />} 
                  label={<FormattedMessage id='workRequest.select.civilEngineering'/>} 
                />
                </Grid>
                <Grid item xs={12} md={2}>
                <FormControlLabel 
                  value={selKind7} 
                  control={<RadioB checked={values.Purpose__c === selKind7 ? true: false} />} 
                  label={<FormattedMessage id='workRequest.select.communicationLineEngineering'/>} 
                />
                </Grid>
                <Grid item xs={12} md={3}>
                <FormControlLabel 
                  value={selKind8} 
                  control={<RadioB checked={values.Purpose__c === selKind8 ? true: false} />} 
                  label={<FormattedMessage id='workRequest.select.workOther'/>} 
                />
                </Grid>
              </Grid>
              </Field>
            </div>
          </FormControl>
        </div>

        {/* その他の場合は入力欄を表示 */}
        {(values && values.Purpose__c === selKind8) &&
          <div className={classes.formControl3}>
          <Field
            id="PurposeOther__c"
            name="PurposeOther__c"
            component={renderTextField}
            label={<FormattedMessage id='workRequest.select.workOther.memo'/>}
            margin="normal"
            variant = "outlined"
            required={true}
            type="text"
            validate={[
              validateRule.required,
              validateRule.maxLength(20)
            ]}
          />
          </div>
        }

        {/* 資料アップロード */}
        <Grid key="keyPhotoFile" item xs={12}>
          <Typography variant="subtitle1" className={classes.typography3}>添付資料アップロード<font size="2">（※10MBまで登録出来ます）</font></Typography>
          <Typography variant="subtitle2" display="inline" className={classes.typographySecBlue}>
            以下の提出例にしたがって、取付希望範囲がわかる資料を添付してください。
          </Typography>
          <p style={{fontSize: 5, height: 1}}></p>
          <Typography variant="body2" className={classes.typographyValue} style={{paddingLeft:"20px"}}>
              ・<u style={{color:'#0000ff', cursor:'hand'}}>
                  <a target="_blank" rel="noopener noreferrer" href={conf.FILE_STYLE_URL}>
                    提出例
                  </a>
                </u>             
            </Typography>
        </Grid>
        <Grid key="keyUploadPhotoFile" item xs={12}>
          <Fragment>
            <div style={{paddingLeft:"20px"}}>
            <UploadPdf
              componentId="pdfFile"
              maxFileCount={10}
              maxFileSize={10485760}
              fileSetHandler={this.setPdfFiles}
              />
              </div>
          </Fragment>
        </Grid>
        <br/>

{/* 取付資材数量 グリッド入力を挿入予定 */}

      <Typography variant="subtitle1" className={classes.typography3}>取付希望数</Typography>
      <Typography variant="subtitle2" display="inline" className={classes.typographySecBlue}>
        取付をご希望する単位数量を入力してください。
      </Typography>
      <Typography variant="subtitle1" className={classes.typography3}>
        <font size="2">※取付希望数が不明な場合は空白で構いません。</font>
      </Typography>
      <p style={{fontSize: 5, height: 1}}></p>
          <Typography variant="body2" className={classes.typographyValue} style={{paddingLeft:"20px"}}>
              ・<u style={{color:'#0000ff', cursor:'hand'}}>
                  <a target="_blank" rel="noopener noreferrer" href={conf.SHIZAI_INPUT_SAMPLE}>
                    資材数量の入力方法例
                  </a>
                </u>            
            </Typography>
        <p style={{fontSize: 5, height: 1}}></p>
            <Grid container spacing={1} XS={12} sm={8} md={6}>
              <Grid container xs={6} md={3} className={classes.containerGridItem}>
                <Field
                  id="HighVolVolume__c"
                  name="HighVolVolume__c"
                  component={renderTextField}
                  label={<font size={2}>高圧線 単位</font>}
                  margin="normal"
                  variant="outlined"
                  type="text"
                  multiline={false}
                  className={classes.fields4}
                  onChange={this.setShizaiSuryo}
                />
              </Grid>
              <div style={{paddingLeft:'0px', width: '10px'}}>
              <Grid item xs={1} md={1} className={classes.container1}>
                <FormLabel component="legend" className={classes.formLabel2}><font size="2">単位</font></FormLabel>      
              </Grid>
              </div>
              <div style={{paddingLeft:'0px'}}>
                <FormGroup row></FormGroup>
                <Field className={classes.fields3}
                  id="HighVolFraction__c"
                  name="HighVolFraction__c"
                  component={renderCheckbox}
                  label=""
                  style={{visibility: "hidden"}}
                />
              </div>              
              <Grid container xs={6} md={3} className={classes.containerGridItem}>          
                <Field
                  id="LowVolVolume__c"
                  name="LowVolVolume__c"
                  component={renderTextField}
                  label={<font size={2}>低圧線 単位</font>}
                  margin="normal"
                  variant="outlined"
                  type="text"
                  multiline={false}
                  className={classes.fields4}
                  onChange={this.setShizaiSuryo}
                />
              </Grid>
              <div style={{paddingLeft: '0px', width: '10px'}}>
              <Grid item xs={1} md={1} className={classes.container1}>
                <FormLabel component="legend" className={classes.formLabel2}><font size="2">単位</font></FormLabel>      
              </Grid>
              </div>
              <div style={{paddingLeft:'0px'}}>
                <FormGroup row></FormGroup>
                <Field className={classes.fields3}
                  id="LowVolFraction__c"
                  name="LowVolFraction__c"
                  component={renderCheckbox}
                  label=""
                  style={{visibility: "hidden"}}
                />
              </div>
            </Grid> 
            <Grid container spacing={1} XS={12} sm={8} md={6}>
              <Grid container xs={6} md={3} className={classes.containerGridItem}>
                <Field
                  id="DropVolume__c"
                  name="DropVolume__c"
                  component={renderTextField}
                  label={<font size={2}>引込線(単線/三線) 単位</font>}
                  margin="normal"
                  variant="outlined"
                  type="text"
                  multiline={false}
                  className={classes.fields4}
                  onChange={this.setShizaiSuryo}
                />  
              </Grid>
              <div style={{paddingLeft:'0px', width: '10px'}}>
              <Grid item xs={1} md={1} className={classes.container1}>
                <FormLabel component="legend" className={classes.formLabel2}><font size="2">単位</font></FormLabel>      
              </Grid>
              </div> 
              <div style={{paddingLeft:'0px'}}>
                <FormGroup row></FormGroup>
                <Field className={classes.fields3}
                  id="DropVolFraction__c"
                  name="DropVolFraction__c"
                  component={renderCheckbox}
                  label=""
                  style={{visibility: "hidden"}}
                />
              </div>           
              <Grid container xs={6} md={3} className={classes.containerGridItem}>     
                <Field
                  id="ComVolume__c"
                  name="ComVolume__c"
                  component={renderTextField}
                  label={<font size={2}>引込線(三線) 単位</font>}
                  margin="normal"
                  variant="outlined"
                  type="text"
                  multiline={false}
                  className={classes.fields4}
                  onChange={this.setShizaiSuryo}
                />
              </Grid>
              <div style={{paddingLeft:'0px', width: '10px'}}>
              <Grid item xs={1} md={1} className={classes.container1}>
                <FormLabel component="legend" className={classes.formLabel2}><font size="2">単位</font></FormLabel>      
              </Grid>
              </div>
              <div style={{paddingLeft:'0px'}}>
                <FormGroup row></FormGroup>
                <Field className={classes.fields3}
                  id="ComVolFraction__c"
                  name="ComVolFraction__c"
                  component={renderCheckbox}
                  label=""
                  style={{visibility: "hidden"}}
                />
              </div>
            </Grid> 
            <Grid container spacing={1} XS={12} sm={8} md={6}>
              <Grid container xs={6} md={3}>
                <Field
                  id="TransOpenVolime__c"
                  name="TransOpenVolime__c"
                  component={renderTextField}
                  label={<font size="2">変圧器・開閉器 個数</font>}
                  margin="normal"
                  variant="outlined"
                  type="text"
                  multiline={false}
                  className={classes.fields4}
                  onChange={this.setShizaiSuryo}
                />
              </Grid>
              <div style={{paddingLeft:'0px', width: '10px'}}>
              <Grid item xs={1} md={1} className={classes.container1}>
                <FormLabel component="legend" className={classes.formLabel2}><font size="2">個</font></FormLabel>      
              </Grid>
              </div>
            </Grid>
          

{/* ご連絡事項 */}
        <Field
          id="Message__c"
          name="Message__c"
          component={renderTextField}
          label={<FormattedMessage id='workRequest.in.memo'/>}
          margin="normal"
          variant="outlined"
          type="text"
          multiline={true}
          className={classes.fields}
          rows={3}
          validate={[
            validateRule.maxLength(1000)
          ]}
        />

{/* オペレータ連絡文言 */}

        <Typography variant="subtitle2"
          style={{display:"inline-block", borderTop: "dashed 1px skyblue",borderBottom: "dashed 1px skyblue",margin:"20px 5px -10px 5px", textAlign: "center", fontSize:"0.8em"}}>
          <FormattedMessage id={'workRequest.message.contact'}/><br />
          { userInfo.data && userInfo.data.Cellphone__c ? userInfo.data.Cellphone__c : userInfo.data.Tel__c }
        </Typography>
        <p></p>
        {(values && values.StartRequireAttachTerm__c && values.EndRequireAttachTerm__c &&
          common.getTermDays(values.StartRequireAttachTerm__c, values.EndRequireAttachTerm__c) >= 365) &&
          <Typography variant="caption" display="inline" className={classes.typographyWarn}>
            取付期間が１年以上のため追加料金が発生します。
          </Typography>
        }
        {(values && values.Witness__c) &&
          <Typography variant="caption" display="inline" className={classes.typographyWarn}>
            現場立合費用が発生します。
          </Typography>
        }
{/* ボタン */}
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          size="large"
          onClick={handleSubmit(this.doWorkRequest)}
          type="submit"
        >
          <span><FormattedMessage id={'common.btn.send'}/></span>
        </Button>
        <Button
          variant="outlined"
          color="primary"
          className={classes.button}
          size="large"
          onClick={this.onClickBack}
        >
          <span><FormattedMessage id={'common.btn.back'}/></span>
        </Button>

      </form>
      </div>
    );
  }
}



const FORM_NAME = "WorkRequest";

WorkRequest.propTypes = {
  classes: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

const mapStateToProps = state => ({
  initialValues: {
    Postalcode__c:null,
    WorkSiteAddress__c:null,
    WorkSitePoleNo1__c:null,
    WorkSitePoleNo2__c:null,
    WorkSitePoleNo3__c:null,
    WorkSitePoleNo4__c:null,
    WorkSitePoleNo5__c:null,
    StartRequireAttachTerm__c:null,
    EndRequireAttachTerm__c:null,
    Purpose__c:'建築・塗装',
    PurposeOther__c:null,
    HighVolVolume__c:null,
    HighVolFraction__c:false,
    LowVolVolume__c:null,
    LowVolFraction__c:false,
    DropVolume__c:null,
    DropVolFraction__c:false,
    ComVolume__c:null,
    ComVolFraction__c:false,
    TransOpenVolime__c:null,
    Witness__c:false,
    Message__c:null,
    OrderCategory__c:"防護管取付",
  },
});

const selector = formValueSelector(FORM_NAME);

WorkRequest = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount : true,
  validate,
  enableReinitialize: true,
})(connect(state => {
  return {
    Postalcode__c: selector(state, 'Postalcode__c'),
    values: getFormValues(FORM_NAME)(state),
  };
})(WorkRequest));

export default withStyles(styles)(
  connect(
    mapStateToProps
  )(injectIntl(WorkRequest))
);
